import styled, { css } from "styled-components/native";
import { StyledProps } from "./model";
import { peacock_blue, spacing_m, white_smoke } from "../../StyleHelpers";

const getSizeStyles = ({ isLandscape, isNarrow, isClip }: StyledProps) => {
	let width: string;
	let aspectRatio: number;

	if (isLandscape) {
		if (isNarrow) {
			width = isClip ? "220px" : "274px";
		} else {
			width = "560px";
		}
		aspectRatio = 17 / 9;
	} else {
		width = isNarrow ? "131px" : "268px";
		aspectRatio = 2.2 / 3;
	}

	return css`
		width: ${width};
		aspect-ratio: ${aspectRatio};
	`;
};

export const StyledSeeMore = styled.View<StyledProps>`
	height: ${({ isResize, size }) => (isResize ? `${size}%` : "100%")};

	${(props) => getSizeStyles(props)}

	background-color: ${peacock_blue};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border-radius: 16px;

	${({ borderEvent }) =>
		borderEvent &&
		css`
			border-style: solid;
			border-color: ${white_smoke};
			border-width: 2px;
			transition: border-color 0.6s ease;
		`}
`;

export const StyledSeeMoreText = styled.Text<{ isNarrow?: boolean }>`
	color: white;
	font-size: ${({ isNarrow }) => (isNarrow ? "20px" : "25px")};
	margin-top: ${spacing_m};
	text-align: center;
`;
